export default __webpack_public_path__ + "static/media/language-title-2-practice.a74969fe.png";